import WalletIcon from '@components/icons/WalletIcon'
import ConnectButton from './ConnectButton'

const ConnectEmptyState = ({ text }: { text: string }) => {
  return (
    <div className="flex flex-col items-center">
      <WalletIcon className="mb-2 size-6 text-th-fgd-4" />
      <p className="mb-4">{text}</p>
      <ConnectButton isSecondary />
    </div>
  )
}

export default ConnectEmptyState
